module.exports = __webpack_public_path__ + "static/img/C4D0038.dee8d20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0038.jpg
// module id = 8bA3
// module chunks = 0